import { assignIfSupported, ITEM_TYPE, TEXT_STYLE } from './ModelHelpers';

export class CancelStepItem {
  constructor(data) {
    Object.assign(this, {
      message: data.message,
      spacing: data.spacing, // Adds to bottom, nullable
      textStyle: assignIfSupported(data.text_style, Object.values(TEXT_STYLE)), // nullable
      type: assignIfSupported(data.type, Object.values(ITEM_TYPE)), // nullable
    });
  }
}
